import { useEffect, useRef } from 'react'

type InlineScriptProps = { html: string }

/**
 * Mounts HTML fragments (including inline &lt;script&gt; tags) once, matching
 * typical static-site generator behavior without an external runtime package.
 */
export default function InlineScript({ html }: InlineScriptProps) {
  const ref = useRef<HTMLDivElement>(null)
  useEffect(() => {
    const el = ref.current
    if (!el || !html) return
    const fragment = document.createRange().createContextualFragment(html)
    el.append(fragment)
    return () => {
      el.replaceChildren()
    }
  }, [html])
  return <div ref={ref} style={{ display: 'contents' }} />
}
